import React from "react";
import {
  makeStyles,
  DialogTitle,
  Dialog,
  IconButton,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

const styles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: "relative",
    flex: 1,
    padding: 16,
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "1px solid",
  },
}));

export default function ImgDialog(props) {
  const {
    img,
    onClose,
    title,
    resetCrop,
    setIsTicket,
    isTicket,
    setCroppedImageTicket,
    setCroppedImageTons,
    croppedAreaPixels,
    setImageTicket,
    setImageTons,
  } = props;
  const classes = styles();

  const handleAceptImage = () => {
    if (isTicket) {
      setIsTicket(false);
      setCroppedImageTicket(croppedAreaPixels);
      setImageTicket(img);
    } else {
      setCroppedImageTons(croppedAreaPixels);
      setImageTons(img);
    }

    resetCrop();
  };

  return (
    <Dialog
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      open={!!img}
      onClose={onClose}
      fullWidth={true}
      maxWidth='xl'
    >
      <DialogTitle
        id='alert-dialog-title'
        style={{ backgroundColor: "#fafafa" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            position: "relative",
            flex: 1,
            padding: 16,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <img src={img} alt='Cropped' className={classes.img} />
          <br />
        </div>
      </DialogContent>
      <DialogActions style={{ color: "white", backgroundColor: "#fafafa" }}>
        <IconButton
          aria-label='delete'
          style={{ color: "red" }}
          onClick={onClose}
        >
          <CancelIcon fontSize='large' />
        </IconButton>
        <IconButton
          aria-label='delete'
          style={{ color: "green" }}
          onClick={handleAceptImage}
        //disabled={imageConfig.isCropping}
        >
          <CheckCircleIcon fontSize='large' />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
}
